import { Button, Select } from "antd";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Creators as CattleProducerActions } from "../../../store/ducks/cattleProducer";
import { ContainerSelectCattleProducer, CustomSelect } from "./styles";

function SelectCattleProducer({
  customSelect = false,
  placeholder = null,
  id,
  name,
  value,
  onDeselect,
  onChange,
  onlyActiveOrPending = true,
  onlyWithProperties = false,
}) {
  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
    translation,
  } = useSelector((state) => state.app);

  const { isCattleProducerListDrowpDownLoading, listDrowpDown } = useSelector(
    (state) => state.cattleProducer
  );

  const dispatch = useDispatch();

  const getCattleProducerList = useCallback(() => {
    dispatch(
      CattleProducerActions.getDropdownCattleProducers(groupId, farmId)
    );
  }, [dispatch, farmId, groupId]);

  const createNewCattleProducer = useCallback(() => {
    dispatch(CattleProducerActions.showDrawer("new"));
  }, [dispatch]);

  useEffect(() => {
    getCattleProducerList();
  }, [getCattleProducerList]);

  const SelectCattleProducerElement = customSelect ? (
    <CustomSelect
      loading={isCattleProducerListDrowpDownLoading}
      name={name}
      id={id}
      value={value || undefined}
      placeholder={
        placeholder
          ? placeholder
          : translation.cattleProducer.select.placeholder
      }
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      allowClear
      onDeselect={onDeselect}
      onChange={onChange}
    >
      {listDrowpDown
        .filter((cattleProducer) =>
          onlyActiveOrPending
            ? cattleProducer.status === "A" ||
              cattleProducer.status === "Active"
            : true
        )
        .filter((cattleProducer) =>
          onlyWithProperties
            ? cattleProducer.properties.length > 0
            : true
        )
        .map((cattleProducer) => (
          <Select.Option key={cattleProducer.id} value={cattleProducer.id}>
            {cattleProducer.name}
          </Select.Option>
        ))}
    </CustomSelect>
  ) : (
    <Select
      loading={isCattleProducerListDrowpDownLoading}
      name={name}
      id={id}
      value={value || undefined}
      placeholder={
        placeholder
          ? placeholder
          : translation.cattleProducer.select.placeholder
      }
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      allowClear
      onDeselect={onDeselect}
      onChange={onChange}
    >
      {listDrowpDown
        .filter((cattleProducer) =>
          onlyActiveOrPending
            ? cattleProducer.status === "A" ||
              cattleProducer.status === "Active"
            : true
        )
        .filter((cattleProducer) =>
          onlyWithProperties
            ? cattleProducer.properties.length > 0
            : true
        )
        .map((cattleProducer) => (
          <Select.Option key={cattleProducer.id} value={cattleProducer.id}>
            {cattleProducer.name}
          </Select.Option>
        ))}
    </Select>
  );

  return (
    <ContainerSelectCattleProducer>
      {SelectCattleProducerElement}
      <Button shape="circle" icon="plus" onClick={createNewCattleProducer} />
    </ContainerSelectCattleProducer>
  );
}

export default SelectCattleProducer;

